import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  count?: number;
  action?: ReactNode;
  className?: string;
}

export function SectionHeader({ title, count, action, className }: SectionHeaderProps) {
  return (
    <div className={cn("flex flex-wrap items-center justify-between gap-3", className)}>
      <div className="flex flex-wrap items-center gap-3">
        <h3 className="text-xs font-bold uppercase tracking-wider text-foreground">
          {title}
        </h3>
        {action}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {count != null && (
          <span className="text-xs text-subtle">{count} this session</span>
        )}
      </div>
    </div>
  );
}
